// Every admin endpoint authorizes server-side against the identity the gateway
// injects from the OAuth2 session, so admin calls must always carry the session
// cookie. In local development the admin base is a cross-origin
// http://localhost:5000, where fetch drops cookies unless asked — hence the
// explicit `credentials: 'include'` rather than relying on the same-origin
// default that happens to work in the deployed build.

/** Thrown for 401 / 403 so callers can say "not authorized" instead of "server error". */
export class AdminAuthError extends Error {
  constructor(status, message) {
    super(message);
    this.name = 'AdminAuthError';
    this.status = status;
  }
}

export function adminFetch(url, options = {}) {
  return window.fetch(url, { credentials: 'include', ...options });
}

/** adminFetch + JSON parse, turning non-OK responses into meaningful errors. */
export async function adminFetchJson(url, options) {
  const res = await adminFetch(url, options);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 401) {
      throw new AdminAuthError(401, body.error || 'Your session has expired — please sign in again.');
    }
    if (res.status === 403) {
      throw new AdminAuthError(403, body.error || 'You do not have admin access to this dashboard.');
    }
    throw new Error(body.error || `Server error ${res.status}`);
  }
  return res.json();
}
